/**
 * Égalité structurelle de valeurs de formulaire (objets, tableaux, primitives) :
 * sert à désactiver « Enregistrer » tant que le brouillon est identique à la
 * dernière version enregistrée.
 */
export function isSameValue(a: unknown, b: unknown): boolean {
  if (Object.is(a, b)) {
    return true;
  }
  if (Array.isArray(a) || Array.isArray(b)) {
    return (
      Array.isArray(a) &&
      Array.isArray(b) &&
      a.length === b.length &&
      a.every((item, index) => isSameValue(item, b[index]))
    );
  }
  if (typeof a !== 'object' || typeof b !== 'object' || a === null || b === null) {
    return false;
  }
  const aRecord = a as Record<string, unknown>;
  const bRecord = b as Record<string, unknown>;
  const keys = new Set([...Object.keys(aRecord), ...Object.keys(bRecord)]);
  return [...keys].every((key) => isSameValue(aRecord[key], bRecord[key]));
}
